<template>
  <div>
    <div v-if="canShowPromoBanners">
      <RenderContent :content="promoBannersContent" />
    </div>
  </div>
</template>

<script lang="ts">

import RenderContent from '~/cms/RenderContent.vue';
import { COMPONENTS } from '~~/constants/cms';
import { CART_DISCOUNT } from '~~/constants/cartDiscounts';

export default defineComponent({
  name: 'PromoBannerContainer',
  components: {
    RenderContent,
  },
  setup() {

    const { load: loadCartDiscounts } = useCartDiscountsStore();

    const {
      loadComponent: promoBannersSearch,
      internalCmsContent: promoBannersContent,
      canShowContent: canShowPromoBanners,
    } = useInternalCms(COMPONENTS.PROMO_BANNERS.SLUG);

    useLazyAsyncData('promo-banner-distinct-products-discount', async () => {

      await loadCartDiscounts([CART_DISCOUNT.DISTINCT_PRODUCTS]);

      return '';

    });

    useLazyAsyncData(`promo-banner-${COMPONENTS.PROMO_BANNERS.SLUG}`, async () => {

      await promoBannersSearch();

      return '';

    });

    return {
      promoBannersContent,
      canShowPromoBanners,
    };

  },
});

</script>
